import React, { useEffect, useState } from 'react'
import './FaqEdit.css'
import { useLocation } from 'react-router-dom';
import { SlArrowDown } from "react-icons/sl";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import AddFaqModal from './AddModal';
import { security_key, Url } from '../../../Services/Api';

const FaqEdit = () => {

    const location = useLocation();
    const data = location.state;

    const [faqsData, setFaqsData] = useState([]);
    const [askQuestion, setAskQuestion] = useState({
        question: '',
        answer: ''
    })
    const [isOpen, setIsOpen] = useState(false);
    const [isCMOpen, setIsCMOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isLoading, setIsloading] = useState(false)

    const handleOpenQuestion = (index) => {
        setCurrentIndex(currentIndex !== index ? index : null);
    }

    const AddFAQModal = () => {
        setShowSuccess(false)
        setMessage(null)
        setIsOpen(true);

    }

    const closeFAQModal = () => {
        setIsOpen(false);
        setAskQuestion({
            question: '',
            answer: ''
        });
        setCurrentEditIndex(null)
    }


    const AddFAQCMModal = () => {
        setIsCMOpen(true);
    }

    const closeFAQCMModal = () => {
        setIsCMOpen(false);
    }



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAskQuestion((prevState) => ({
            ...prevState,
            [name]: value
        }))
    }

    // Fetch FAQs from API by slug
    const getFaqsBySlug = async () => {
        const token = sessionStorage.getItem('authToken');

        try {
            const res = await axios.get(`${Url}/api/v1/category-faqs/get-by-slug/${data.slug}`);
            if (res.data && res.data.data) {
                setFaqsData(res.data.data.faqs || []);
            }
        } catch (error) {
            console.error('Error fetching FAQs:', error);
        }
    }

    useEffect(() => {
        if (data?.slug) {
            getFaqsBySlug();
        }
    }, [data?.slug]);

    const [showSuccess, setShowSuccess] = useState(false);
    const [message, setMessage] = useState(null)


    const handleAddFaq = async () => {
        try {


            if (!askQuestion.question || !askQuestion.answer) {
                alert("Please enter both question and answer.");
                return;
            }

            let updatedFaqs = [...faqsData];

            if (currentEditIndex !== null) {
                // Update existing FAQ
                updatedFaqs[currentEditIndex] = askQuestion;
            } else {
                // Add new FAQ
                updatedFaqs.push(askQuestion);
            }

            setIsloading(true)

            const payload = {
                ref_id: data.ref_id,
                faqs: updatedFaqs
            };
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };


            const res = await axios.post(`${Url}/api/v1/category-faqs/add-update`, payload, { headers: headers });

            if (res.data && (res.data.data || res.data.message)) {
                currentEditIndex !== null ? setMessage("FAQ has been Updated successfully.") : setMessage("FAQ has been Added successfully.");
                setShowSuccess(true)
                // setIsOpen(false);
                setAskQuestion({ question: '', answer: '' });
                setCurrentEditIndex(null);
                getFaqsBySlug();
                setIsloading(false)
            }
        } catch (error) {
            console.error("Error adding/updating FAQ:", error);
            alert("Failed to add/update FAQ.");
            setIsloading(false)
        }
    };



    const [categories, setCategories] = useState([]);

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${Url}/api/v1/category-faqs/get-cat`);
            if (res.data && res.data.data) {
                setCategories(res.data.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        if (isCMOpen) {
            fetchCategories();
        }
    }, [isCMOpen]);


    const handleCopy = async (fromRefId) => {
        try {
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };

            if (!data?.ref_id) {
                alert("Destination category (to_ref_id) not found.");
                return;
            }

            const payload = {
                from_ref_id: fromRefId,
                to_ref_id: data.ref_id
            };

            const res = await axios.post(`${Url}/api/v1/category-faqs/bulk-copy`, payload, { headers: headers });

            if (res.data && res.data.message) {
                alert("FAQs copied successfully.");
                closeFAQCMModal();
                getFaqsBySlug(); // Refresh FAQs in your current category if needed
            }
        } catch (error) {
            console.error("Error copying FAQs:", error);
            alert("Failed to copy FAQs.");
        }
    };

    const [currentEditIndex, setCurrentEditIndex] = useState(null);


    const handleDelete = async (deleteIndex) => {
        const token = sessionStorage.getItem('authToken');
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        try {
            const updatedFaqs = faqsData.filter((_, index) => index !== deleteIndex);

            const payload = {
                ref_id: data.ref_id,
                faqs: updatedFaqs
            };

            const res = await axios.post(`${Url}/api/v1/category-faqs/add-update`, payload,{headers:headers});

            if (res.data && (res.data.data || res.data.message)) {
                alert("FAQ deleted successfully.");
                getFaqsBySlug();
            }
        } catch (error) {
            console.error("Error deleting FAQ:", error);
            alert("Failed to delete FAQ.");
        }
    };


    const handleEdit = (editIndex) => {
        setCurrentEditIndex(null)
        const selectedFaq = faqsData[editIndex];
        setAskQuestion(selectedFaq);
        setIsOpen(true);

        // Optional: You can track the editing index to distinguish between add and update
        setCurrentEditIndex(editIndex);
    };





    return (
        <div className='faq-edit-main-container'>
            <div className='faq-editor-head'>
                <h3>{data.title} FAQs</h3>
                <div className='faq-editor-head-1' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
                    <button onClick={AddFAQCMModal}>
                        Copy
                    </button>
                    <button onClick={AddFAQModal}>
                        Add
                    </button>
                </div>
            </div>

            <div className='faq-editor-body'>
                <div className='faq-editor-categories'>
                    {faqsData.map((faq, index) => (
                        <div className='single-faq-editor' key={index}>
                            <div className='faq-editor-questions'>
                                <p onClick={() => handleOpenQuestion(index)}>{faq.question}</p>
                                <div className='faq-action-btns'>
                                    <button
                                        className={`faq-editor-arrow ${currentIndex === index ? 'rotate-faq-btn' : ''}`}
                                        onClick={() => handleOpenQuestion(index)}
                                    >
                                        <SlArrowDown size={15} color='#595959' />
                                    </button>
                                    <button className='faq-editor-arrow' onClick={() => handleEdit(index)}>
                                        <CiEdit size={15} color='#595959' />
                                    </button>
                                    <button className='faq-editor-arrow' onClick={() => handleDelete(index)}>
                                        <MdDelete size={15} color='#595959' />
                                    </button>
                                </div>
                            </div>
                            <div className={`faq-editor-answers ${currentIndex === index ? 'show-answer' : ''}`}>
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>

            <AddFaqModal isLoading={isLoading} isOpen={isOpen} closeFAQModal={closeFAQModal} askQuestion={askQuestion} handleInputChange={handleInputChange} handleAddFaq={handleAddFaq} showSuccess={showSuccess} message={message} />

            <div className={`copy-faq-modal ${isCMOpen ? 'show-modal' : ''}`} onClick={closeFAQCMModal}>
                <div className='add-faq-inner-modal' onClick={(e) => e.stopPropagation()}>
                    <h3 style={{ marginBottom: '15px' }}>Select a Category to Copy FAQs From</h3>

                    <div style={{ maxHeight: '300px', overflowY: 'auto', width: '400px' }}>
                        {categories.length === 0 ? (
                            <p>No categories found.</p>
                        ) : (
                            categories.map((cat, index) => (
                                <div className="category-row" key={index}>
                                    <div className="category-details">
                                        <p className="category-name">{cat.categoryName}</p>
                                        <p className="category-slug">{cat.slug}</p>
                                    </div>
                                    <button className="copy-btn" onClick={() => handleCopy(cat.ref_id)}>Copy FAQs</button>
                                </div>

                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FaqEdit
